import React from "react";
import { Formik } from "formik";
import {
    withStyles,
    Button,
    Typography,
    CircularProgress,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }
});

const UnpairedProductForceCreateForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations, collies, orderData } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize={false}
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isValid, dirty, handleChange, handleSubmit, isSubmitting } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["order_select"] || "Please select  order"}</InputLabel>
                                <Select
                                    name="OrderID"
                                    label={translations["order"] || "Order"}
                                    margin={"dense"}
                                    value={values.OrderID || ''}
                                    onChange={handleChange}
                                    disabled={!values.OverwriteData}
                                >
                                    {(orderData ? [...orderData] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["transport_colli_select"] || "Please select transport colli"}</InputLabel>
                                <Select
                                    name="TransportColliID"
                                    label={translations["transport_colli"] || "Transport Colli"}
                                    margin={"dense"}
                                    value={values.TransportColliID || ''}
                                    onChange={handleChange}
                                    disabled={!values.OverwriteData}
                                >
                                    {(orderData ? [...orderData] : []).map(option => (
                                        option.value === values.OrderID ?
                                            option.TransportCollies.map(index => (
                                                <MenuItem key={index.value} value={index.value}>
                                                    {index.displayValue}
                                                </MenuItem>
                                            )) : null
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["colli_select"] || "Please select colli"}</InputLabel>
                                <Select
                                    name="ColliID"
                                    label={translations["colli"] || "Colli"}
                                    margin={"dense"}
                                    value={values.ColliID || ''}
                                    onChange={handleChange}
                                    disabled={!values.OverwriteData}
                                >
                                    {(collies ? [...collies] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={"OverwriteData"}
                                            checked={undefined}
                                            onChange={handleChange}
                                            margin={"dense"}
                                            color={'primary'}
                                        />
                                    }
                                    label={translations["overwrite_palettes"] || "Overwrite palettes"}
                                />
                            </FormGroup>
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(UnpairedProductForceCreateForm);